import { oz } from '@weft/utils';
import { CONTRACT_CREATION_TYPES } from './contract-creation-type-schema';
import { NewContractSchema } from './new-contract-schema';

export const NewContractSchemaWithoutPlan = oz.object({
  creationType: oz.literal(CONTRACT_CREATION_TYPES.CreateContractWithoutPlan),
  contracts: oz.array(NewContractSchema.omit({ endDate: true })),
}).openapi('NewContractWithoutPlan');

export type NewContractWithoutPlan = oz.infer<typeof NewContractSchemaWithoutPlan>;